import { render, staticRenderFns } from "./CalculateAvg.vue?vue&type=template&id=6c559d06&scoped=true&"
import script from "./CalculateAvg.vue?vue&type=script&lang=js&"
export * from "./CalculateAvg.vue?vue&type=script&lang=js&"
import style0 from "./CalculateAvg.vue?vue&type=style&index=0&id=6c559d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c559d06",
  null
  
)

export default component.exports